var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container", style: _vm.containerStyle }, [
    _c("div", { staticClass: "d-inline-block" }, [
      _vm.hasImage
        ? _c("img", {
            style: _vm.style,
            attrs: { src: _vm.imageUrl, alt: _vm.metadata.tooltip }
          })
        : _c("i", {
            staticClass: "fa fa-file-image fa-5x",
            style: _vm.placeholderStyle
          })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }